import { NgClass } from '@angular/common';
import { Component, DestroyRef } from '@angular/core';
import { BaseModal } from 'shared/abstract/base-modal';

import { Idle } from '@ng-idle/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-session-inactivity',
    templateUrl: './session-inactivity-modal.component.html',
    styleUrls: ['../modal.component.scss'],
    imports: [TranslateModule, NgClass],
})
export class SessionInactivityModalComponent extends BaseModal {
    public data: any;
    protected countdown!: number;
    protected minutes!: number;
    protected seconds!: number;

    protected minutesText: string = '';
    protected secondsText: string = '';

    constructor(
        private idle: Idle,
        private destroyRef: DestroyRef,
        private translate: TranslateService,
    ) {
        super();

        this.minutesText = this.translate.instant('generalKeywords.sessionInactivityModal.minutes');
        this.secondsText = this.translate.instant('generalKeywords.sessionInactivityModal.seconds');

        // do something as the timeout countdown does its thing
        idle.onTimeoutWarning
            .pipe(
                tap(() => idle.clearInterrupts()),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((seconds) => {
                this.countdown = seconds;
                this.processTime();
            });
    }

    private processTime() {
        this.minutes = Math.floor(this.countdown / 60);
        this.seconds = this.countdown % 60;
    }

    public close(result: boolean): void {
        this.closeModalInstance(result);
    }
}
